import React from 'react';

import { createStyles, Grid, Theme, withStyles, WithStyles } from '@material-ui/core';
import { Appointment } from 'requests/resources/appointment';

import { CardAppointmentStatus } from 'components/v2';
import { useLumaBotContext } from '../LumaBot.context';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    container: {
      marginBottom: unit,
      marginLeft: unit * 4,
      maxWidth: '264px',
    },
  });

export interface MessageBookStatusProps extends WithStyles<typeof styles> {
  flowId: string;
}

const MessageBookStatus: React.FC<MessageBookStatusProps> = ({ classes, flowId }) => {
  const { currentAvailabilitiesList } = useLumaBotContext();

  const appointment = currentAvailabilitiesList[flowId] as Appointment;

  if (!appointment) return null;

  return (
    <Grid container className={classes.container}>
      <CardAppointmentStatus appointment={appointment as Appointment} compact />
    </Grid>
  );
};

export default withStyles(styles, { name: 'MessageBookStatus' })(MessageBookStatus);
